var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`height:calc(100vh - ${_vm.minusHeight}px)`)},[_c('div',{attrs:{"id":`${_vm.randomId}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }